import {
  all, fork, takeLatest, take, put, select, call,
} from 'redux-saga/effects';

// auth actions and sagas
import { sendSellerAgreement, updateSellerAgreement } from 'store/actions/authActions';
import { getUserDataFromAccessToken } from 'store/sagas/auth';

// api
import Api from 'api/user';

// storage helpers functions
import * as storage from 'now-frontend-shared/utils/storage';

function* ensureSendSellerAgreement({ payload }) {
  const {
    resolve,
    reject,
    ...payloadRest
  } = payload;
  const accessToken = JSON.parse(storage.getStorageItem('accessToken', '{}'));
  const isAuthorized = yield select(({ auth }) => auth.authInfo.isAuthorized);
  const companyId = yield select(({ auth }) => auth.user.companyId);
  try {
    if (!companyId) {
      const e = new Error();
      e.response = {
        data: {
          message: "You don't have a company",
        },
      };
      throw e;
    }
    yield call(Api.sendSellerAgreement, { url: `/companies/${companyId}/seller-agreement`, data: JSON.stringify(payloadRest) });
    if (isAuthorized) yield call(getUserDataFromAccessToken, { accessToken });
    yield put({ type: sendSellerAgreement.success });
    if (resolve) {
      resolve();
    }
  } catch (err) {
    yield put({
      type: sendSellerAgreement.failure,
      err,
    });
    if (reject) {
      reject(err);
    }
  }
}

function* watchSendingSellerAgreement() {
  yield takeLatest(sendSellerAgreement.type, ensureSendSellerAgreement);
  yield take(sendSellerAgreement.success);
}

function* ensureUpdateSellerAgreement({ payload }) {
  let resolve;
  let reject;
  if (payload) {
    ({ resolve, reject } = payload);
  }
  try {
    const accessToken = JSON.parse(storage.getStorageItem('accessToken', '{}'));
    yield call(Api.updateSellerAgreement, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    yield call(getUserDataFromAccessToken, { accessToken });
    yield put({ type: updateSellerAgreement.success });
    if (resolve) {
      resolve();
    }
  } catch (err) {
    yield put({ type: updateSellerAgreement.failure, err });
    if (reject) {
      reject();
    }
  }
}

function* watchUpdateSellerAgreement() {
  yield takeLatest(updateSellerAgreement.type, ensureUpdateSellerAgreement);
  yield take(updateSellerAgreement.success);
}

export default function* sellerAgreementSagas() {
  yield all([fork(watchSendingSellerAgreement), fork(watchUpdateSellerAgreement)]);
}
